import React from 'react';
import "./styles.less"

interface MapCarouselProps {
    items: React.ReactNode[];
    visibleItems?: number;
    itemHeight?: number;
    currentIndex: number
}

export const MapCarousel = ({
    items,
    itemHeight = 175, 
    currentIndex
}: MapCarouselProps) => {
    return (
        <div
          className="carousel-container"
          style={{
            height: "100%",
          }}
        >
          <div
            className="carousel-track"
            style={{
              transform: `translateY(-${((currentIndex * itemHeight) + (10 * currentIndex))}px)`,  //10 el espaciado del gap.
              transition: 'transform 0.3s ease-in-out',
            }}
          >
            {items.map((item, index) => (
              <div
                key={index}
                className="carousel-item"
                style={{ height: `${itemHeight}px` }}
              >
                {item}
              </div>
            ))}
          </div>
        </div>
    );
}